import {Route} from 'react-router-dom';

import {ROUTE_PATH} from 'constants/routes';
import {ROUTE_CONFIG} from 'utils/route-config';
import {AuthRoute, PrivateRoute} from 'utils/routes';

import {AccountActivation} from './AccountActivation';
import {AccountBlocked} from './AccountBlocked';
import {AuthLayoutRoute, AUTH_LAYOUT_PATHS} from './AuthLayoutRoute';
import {Conference} from './Conference';
import {JoinSessionPage} from './JoinSession';
import {JoinSessionIntegration} from './JoinSession/JoinSessionIntegration';
import {PasswordExpired} from './PasswordExpired';
import {ServerConnectionError} from './ServerConnectionError';
import {SessionFileRedirect} from './SessionFileRedirect';
import {TestPage} from './Test';

export const userRoutes = [
    <AuthRoute key='auth-layout' path={AUTH_LAYOUT_PATHS} component={AuthLayoutRoute} />,
    <PrivateRoute key='account-activation' {...ROUTE_CONFIG.ACCOUNT_ACTIVATION.SELF} component={AccountActivation} />,
    <PrivateRoute key='account-blocked' {...ROUTE_CONFIG.ACCOUNT_BLOCKED.SELF} component={AccountBlocked} />,
    <PrivateRoute key='password-expired' {...ROUTE_CONFIG.PASSWORD_EXPIRED} component={PasswordExpired} />,

    <AuthRoute key='server-connection-error' exact path={ROUTE_PATH.USER.ERROR.SERVER_CONNECTION} component={ServerConnectionError} />,
    <AuthRoute key='conference' exact path={ROUTE_PATH.USER.CONFERENCE._SELF} component={Conference} />,
    <AuthRoute key='join-session' exact path={ROUTE_PATH.SESSION.JOIN._SELF} component={JoinSessionPage} />,
    <AuthRoute key='conference-assistant' exact path={ROUTE_PATH.USER.CONFERENCE.ASSISTANT} component={Conference} />,
    <AuthRoute key='test' path={ROUTE_PATH.TEST._SELF} component={TestPage} />,
    <AuthRoute key='session-file-redirect' exact path={ROUTE_PATH.SESSION.FILE_REDIRECT} component={SessionFileRedirect} />,
    <Route key='join-session-integration' exact path={ROUTE_PATH.SESSION.JOIN.AGENT_INTEGRATION} component={JoinSessionIntegration} />,
];
